// redux saga import
import { takeLatest, call, put, all, fork } from "redux-saga/effects";
import { TIME_ENTRIES_SUMMARY_DAILY_REQUEST } from "./actionType";
import {
  timeEntriesSummaryDailySuccess,
  timeEntriesSummaryDailyFailure,
} from "./action";

import { timeEntriesSummaryDailyApi } from "../../helpers/fakebackend_helper";

function* timeEntriesSummaryDailySaga() {
  try {
    const response = yield call(timeEntriesSummaryDailyApi);
    yield put(timeEntriesSummaryDailySuccess(response));
  } catch (error) {
    yield put(timeEntriesSummaryDailyFailure(error));
  }
}

function* watchTimeEntriesSummaryDailySaga() {
  yield takeLatest(
    TIME_ENTRIES_SUMMARY_DAILY_REQUEST,
    timeEntriesSummaryDailySaga
  );
}

export default function* TimeEntriesSummary() {
  yield all([watchTimeEntriesSummaryDailySaga()]);
}
